<div
  *ngIf="isVisible"
  class="relative z-50"
  aria-labelledby="modal-title"
  role="dialog"
  aria-modal="true"
>
  <!-- Background backdrop -->
  <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 backdrop-blur-sm transition-opacity" (click)="close()"></div>

  <!-- Modal container -->
  <div class="fixed inset-0 z-10 w-screen overflow-y-auto" (click)="close()">
    <div
      class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
    >
      <div
        class="px-3 pt-3 pb-2 relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl"
        (click)="$event.stopPropagation()"
      >
        <div>
          <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
            <button
              type="button"
              (click)="close()"
              class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
            >
              <span class="sr-only">Close</span>
              <svg
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div class="sm:flex sm:items-start px-2 py-2 lg:px-3 lg:py-3">
            <div class="mt-3 sm:mt-0 w-full">
              <!-- Company Header -->
              <div class="flex items-center space-x-3 mb-6">
                <img
                  [src]="'https://ui-avatars.com/api/?background=FFA500&color=fff&rounded=false&name=' + (company?.company_name?.substring(0, 2) || 'NA') + '&format=svg&size=128'"
                  [alt]="company?.company_name"
                  class="h-16 w-16 flex-none rounded-lg bg-gray-50"
                />
                <div class="flex-1">
                  <h3
                    class="text-2xl text-gray-700 font-extrabold leading-6 mb-1"
                    id="modal-title"
                  >
                    {{ company?.company_name || 'Company Name' }}
                  </h3>
                  <p class="text-sm text-gray-500 font-normal font-poppins">
                    {{ getLocation(company?.main_address) }}
                  </p>

                </div>
              </div>

              <!-- Description Section -->
              <div *ngIf="hasAnyDescription()" class="bg-gray-50/50 p-4 rounded-lg mb-3 relative">
                <h4 class="font-semibold font-poppins text-gray-700 mb-2">Description</h4>
                <p class="text-sm text-gray-600 whitespace-pre-line">
                  {{ getVisibleDescription() }}
                </p>
                <div class="flex items-center justify-between mt-3">
                  <button
                    *ngIf="shouldShowDescriptionToggle()"
                    (click)="toggleDescription()"
                    class="text-primary hover:opacity-90 text-xs font-medium transition-colors"
                  >
                    {{ showFullDescription ? 'Show less' : 'Show more' }}
                  </button>
                  <div class="flex items-center gap-2 ml-auto">
                    <button
                      *ngIf="hasExtractedDescription()"
                      (click)="selectDescriptionType('extracted')"
                      class="text-xs font-medium px-3 py-1 rounded-full transition-colors"
                      [ngClass]="selectedDescriptionType === 'extracted' ? 'bg-primary text-white' : 'bg-gray-50 text-gray-500 hover:bg-gray-100 hover:opacity-90'"
                    >
                      Extracted
                    </button>
                    <button
                      *ngIf="hasGeneratedDescription()"
                      (click)="selectDescriptionType('generated')"
                      class="text-xs font-medium px-3 py-1 rounded-full transition-colors flex items-center gap-1"
                      [ngClass]="selectedDescriptionType === 'generated' ? 'bg-primary text-white' : 'bg-gray-50 text-gray-500 hover:bg-gray-100 hover:opacity-90'"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" data-slot="icon" class="size-3" [ngClass]="selectedDescriptionType === 'generated' ? 'fill-white' : 'fill-gray-500'">
                        <path fill-rule="evenodd" d="M5 4a.75.75 0 0 1 .738.616l.252 1.388A1.25 1.25 0 0 0 6.996 7.01l1.388.252a.75.75 0 0 1 0 1.476l-1.388.252A1.25 1.25 0 0 0 5.99 9.996l-.252 1.388a.75.75 0 0 1-1.476 0L4.01 9.996A1.25 1.25 0 0 0 3.004 8.99l-1.388-.252a.75.75 0 0 1 0-1.476l1.388-.252A1.25 1.25 0 0 0 4.01 6.004l.252-1.388A.75.75 0 0 1 5 4ZM12 1a.75.75 0 0 1 .721.544l.195.682c.118.415.443.74.858.858l.682.195a.75.75 0 0 1 0 1.442l-.682.195a1.25 1.25 0 0 0-.858.858l-.195.682a.75.75 0 0 1-1.442 0l-.195-.682a1.25 1.25 0 0 0-.858-.858l-.682-.195a.75.75 0 0 1 0-1.442l.682-.195a1.25 1.25 0 0 0 .858-.858l.195-.682A.75.75 0 0 1 12 1ZM10 11a.75.75 0 0 1 .728.568.968.968 0 0 0 .704.704.75.75 0 0 1 0 1.456.968.968 0 0 0-.704.704.75.75 0 0 1-1.456 0 .968.968 0 0 0-.704-.704.75.75 0 0 1 0-1.456.968.968 0 0 0 .704-.704A.75.75 0 0 1 10 11Z" clip-rule="evenodd"></path>
                      </svg>
                      Generated
                    </button>
                  </div>
                </div>
              </div>

              <!-- Company Details Grid -->
              <div class="grid grid-cols-1 md:grid-cols-4 gap-3">

                <!-- Basic Information -->
                <div class="col-span-4 md:col-span-2 bg-gray-50/50 p-4 rounded-lg">
                  <h4 class="font-semibold font-poppins text-gray-700 mb-3">Basic Information</h4>
                  <div class="space-y-2 text-sm !font-poppins">
                    <div class="flex justify-between bg-gray-50 rounded px-2 py-0.5 -mx-2">
                      <span class="text-gray-500">Industry:</span>
                      <span class="text-gray-700 font-medium">{{ company?.main_industry || 'Not available' }}</span>
                    </div>
                    <div class="flex justify-between">
                      <span class="text-gray-500">Employee Count:</span>
                      <span class="text-gray-700 font-medium">{{ formatEmployeeCount(company?.employee_count?.value) }}</span>
                    </div>
                    <div class="flex justify-between bg-gray-50 rounded px-2 py-0.5 -mx-2">
                      <span class="text-gray-500">Revenue:</span>
                      <span class="text-gray-700 font-medium">${{ formatRevenue(company?.revenue?.value) }}</span>
                    </div>
                    <div class="flex justify-between">
                      <span class="text-gray-500">Year Founded:</span>
                      <span class="text-gray-700 font-medium">{{ company?.year_founded || 'Not available' }}</span>
                    </div>
                  </div>
                </div>

                <!-- Contact Information -->
                <div class="col-span-4 md:col-span-2 bg-gray-50/50 p-4 rounded-lg">
                  <h4 class="font-semibold font-poppins text-gray-700 mb-3">Contact Information</h4>
                  <div class="space-y-2 !font-poppins">
                    <div class="bg-gray-50 rounded px-2 py-0.5 -mx-2">
                      <div class="flex justify-between items-center gap-2 text-sm">
                        <span class="text-gray-500 shrink-0">Phone:</span>
                        <a *ngIf="primaryPhone; else noPhone" [href]="'tel:' + primaryPhone" class="text-gray-700 font-medium truncate hover:text-primary">{{ primaryPhone }}</a>
                        <ng-template #noPhone><span class="text-gray-700 font-medium">Not available</span></ng-template>
                      </div>
                      <div *ngIf="extraPhoneCount > 0" class="flex justify-end mt-0.5">
                        <button type="button" (click)="openContactList('phone')"
                                class="text-primary hover:opacity-90 text-xs font-medium whitespace-nowrap transition-colors">
                          View more (+{{ extraPhoneCount }})
                        </button>
                      </div>
                    </div>
                    <div class="text-sm">
                      <div class="flex justify-between items-center gap-2">
                        <span class="text-gray-500 shrink-0">Email:</span>
                        <a *ngIf="primaryEmail; else noEmail" [href]="'mailto:' + primaryEmail" class="text-gray-700 font-medium truncate hover:text-primary">{{ primaryEmail }}</a>
                        <ng-template #noEmail><span class="text-gray-700 font-medium">Not available</span></ng-template>
                      </div>
                      <div *ngIf="extraEmailCount > 0" class="flex justify-end mt-0.5">
                        <button type="button" (click)="openContactList('email')"
                                class="text-primary hover:opacity-90 text-xs font-medium whitespace-nowrap transition-colors">
                          View more (+{{ extraEmailCount }})
                        </button>
                      </div>
                    </div>
                    <div class="flex justify-between text-sm bg-gray-50 rounded px-2 py-0.5 -mx-2">
                      <span class="text-gray-500">Address:</span>
                      <span class="text-gray-700 font-medium text-right">{{ getLocation(company?.main_address) }}</span>
                    </div>
                  </div>
                </div>

                <!-- Additional Details -->
                <div class="col-span-4 md:col-span-3 bg-gray-50/50 p-4 rounded-lg">
                  <h4 class="font-semibold text-gray-700 mb-3">Additional Details</h4>
                  <div class="flex flex-wrap items-center gap-3 text-sm text-gray-500">
                    <span class="font-medium">
                      Legal Name: <span class="text-gray-700">{{ getLegalName(company?.company_legal_names) || 'Not available' }}</span>
                    </span>
                    <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium font-poppins bg-gray-50 text-gray-500 cursor-default"
                          matTooltip="Type"
                          matTooltipPosition="above"
                          matTooltipClass="custom-tooltip">
                      {{ company?.company_type || 'Not available' }}
                    </span>
                    <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium font-poppins bg-gray-50 text-gray-500 cursor-default"
                          matTooltip="Status"
                          matTooltipPosition="above"
                          matTooltipClass="custom-tooltip">
                      {{ company?.status || 'Active' }}
                    </span>
                  </div>
                </div>

                <!-- Website & Social Media -->
                <div class="col-span-4 md:col-span-1" [ngClass]="hasSocialMedia(company) ? 'flex flex-col gap-1.5' : ''">

                  <!-- Website button - flexible height -->
                  <a *ngIf="company?.website_url" [href]="company.website_url" target="_blank"
                     class="bg-gray-50/50 rounded-lg inline-flex justify-center items-center text-sm font-medium text-primary hover:opacity-90 w-full"
                     [ngClass]="hasSocialMedia(company) ? 'flex-1' : 'h-[88px]'">
                    Website
                  </a>

                  <!-- Social Media Grid - only show when social media exists -->
                  <div *ngIf="hasSocialMedia(company)" class="grid grid-cols-5 gap-1.5 flex-1">

                    <!-- Facebook -->
                    <a *ngIf="company?.facebook_url" [href]="company.facebook_url" target="_blank"
                       class="bg-gray-50/50 p-2 rounded-lg text-primary hover:opacity-90 transition-colors flex justify-center items-center">
                      <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path fill-rule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clip-rule="evenodd" />
                      </svg>
                    </a>

                    <!-- Instagram -->
                    <a *ngIf="company?.instagram_url" [href]="company.instagram_url" target="_blank"
                       class="bg-gray-50/50 p-2 rounded-lg text-primary hover:opacity-90 transition-colors flex justify-center items-center">
                      <svg viewBox="0 0 24 24" aria-hidden="true" class="h-5 w-5 fill-current">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465.668.25 1.272.644 1.772 1.153.509.5.902 1.104 1.153 1.772.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.903 4.903 0 0 1-1.153 1.772c-.5.509-1.104.902-1.772 1.153-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.903 4.903 0 0 1-1.772-1.153 4.902 4.902 0 0 1-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 0 1 1.153-1.772A4.902 4.902 0 0 1 5.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63Zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.096 3.096 0 0 0-.748-1.15 3.098 3.098 0 0 0-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058ZM12 6.865a5.135 5.135 0 1 1 0 10.27 5.135 5.135 0 0 1 0-10.27Zm0 1.802a3.333 3.333 0 1 0 0 6.666 3.333 3.333 0 0 0 0-6.666Zm5.338-3.205a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4Z"></path>
                      </svg>
                    </a>

                    <!-- Twitter/X -->
                    <a *ngIf="company?.twitter_url" [href]="company.twitter_url" target="_blank"
                       class="bg-gray-50/50 p-2 rounded-lg text-primary hover:opacity-90 transition-colors flex justify-center items-center">
                      <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.0956Z" />
                      </svg>
                    </a>

                    <!-- YouTube -->
                    <a *ngIf="company?.youtube_url" [href]="company.youtube_url" target="_blank"
                       class="bg-gray-50/50 p-2 rounded-lg text-primary hover:opacity-90 transition-colors flex justify-center items-center">
                      <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path fill-rule="evenodd" d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z" clip-rule="evenodd" />
                      </svg>
                    </a>

                    <!-- LinkedIn -->
                    <a *ngIf="company?.linkedin_url" [href]="company.linkedin_url" target="_blank"
                       class="bg-gray-50/50 p-2 rounded-lg text-primary hover:opacity-90 transition-colors flex justify-center items-center">
                      <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z"></path>
                      </svg>
                    </a>

                  </div>

                </div>

                <!-- Business Tags -->
                <div *ngIf="company?.business_tags_generated?.length > 0" class="col-span-4 bg-gray-50/50 p-4 rounded-lg">
                  <h4 class="font-semibold text-gray-700 mb-3">Business Tags</h4>
                  <div class="flex flex-wrap gap-2">
                    <span *ngFor="let tag of getVisibleBusinessTags()" class="inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium bg-gray-50 text-gray-500">
                      {{ tag }}
                    </span>
                  </div>
                  <button *ngIf="company.business_tags_generated.length > 10"
                          (click)="toggleBusinessTags()"
                          class="mt-3 text-primary hover:opacity-90 text-xs font-medium transition-colors">
                    {{ showAllBusinessTags ? 'Show less' : 'Show more (' + (company.business_tags_generated.length - 10) + ' more)' }}
                  </button>
                </div>

                <!-- Technologies -->
                <div *ngIf="company?.technologies?.length > 0" class="col-span-4 bg-gray-50/50 p-4 rounded-lg">
                  <h4 class="font-semibold text-gray-700 mb-3">Technologies</h4>
                  <div class="flex flex-wrap gap-2">
                    <span *ngFor="let tech of getVisibleTechnologies()" class="inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium bg-gray-50 text-gray-500">
                      {{ tech }}
                    </span>
                  </div>
                  <button *ngIf="company.technologies.length > 10"
                          (click)="toggleTechnologies()"
                          class="mt-3 text-primary hover:opacity-90 text-xs font-medium transition-colors">
                    {{ showAllTechnologies ? 'Show less' : 'Show more (' + (company.technologies.length - 10) + ' more)' }}
                  </button>
                </div>

              </div>

              <!-- Close Button -->
              <!--
              <div class="flex justify-center pt-6">
                <button
                  type="button"
                  (click)="close()"
                  class="btn btn-rounded px-6"
                >
                  Close
                </button>
              </div>
              -->

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- "View more" sub-modal: full list of phones / emails -->
  <div *ngIf="contactListOpen" class="relative z-[60]" role="dialog" aria-modal="true" [attr.aria-label]="contactListTitle">
    <div class="fixed inset-0 bg-secondary-900 bg-opacity-60 backdrop-blur-sm transition-opacity" (click)="closeContactList()"></div>
    <div class="fixed inset-0 z-10 w-screen overflow-y-auto" (click)="closeContactList()">
      <div class="flex min-h-full items-end justify-center p-4 sm:items-center">
        <div class="relative w-full sm:max-w-md transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all"
             (click)="$event.stopPropagation()">

          <!-- Header -->
          <div class="flex items-center justify-between border-b border-gray-100 px-5 py-3">
            <h3 class="font-semibold font-poppins text-gray-700">
              {{ contactListTitle }}
              <span class="text-gray-400 font-normal">({{ contactListItems.length }})</span>
            </h3>
            <button type="button" (click)="closeContactList()" class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none">
              <span class="sr-only">Close</span>
              <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <!-- Scrollable list -->
          <ul class="max-h-80 overflow-y-auto divide-y divide-gray-100 custom-scroll">
            <li *ngFor="let item of contactListItems" class="flex items-center justify-between gap-3 px-5 py-2.5 hover:bg-gray-50">
              <a [href]="(contactListType === 'phone' ? 'tel:' : 'mailto:') + item"
                 class="text-sm text-gray-700 truncate hover:text-primary !font-poppins">{{ item }}</a>
              <button type="button" (click)="copyContact(item)"
                      class="shrink-0 text-gray-400 hover:text-primary transition-colors"
                      [matTooltip]="copiedValue === item ? 'Copied!' : 'Copy'"
                      matTooltipPosition="left" matTooltipClass="custom-tooltip">
                <svg *ngIf="copiedValue !== item" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184" />
                </svg>
                <svg *ngIf="copiedValue === item" class="h-4 w-4 text-primary" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                </svg>
              </button>
            </li>
          </ul>

        </div>
      </div>
    </div>
  </div>

</div>
